import Enum from 'common/enums/Enum';

export const FieldTypeEnum = new Enum({
    PlacesSearch: 'PlacesSearch',
    WorkingDays: 'WorkingDays',
    WorkingDaysWithOffset: 'WorkingDaysWithOffset',
    MultiDaySlots: 'MultiDaySlots',
    Contact: 'Contact',
    Team: 'Team',
    Teams: 'Teams',
    Map: 'Map',
    Phone: 'Phone',
    City: 'City',
    Pincode: 'Pincode',
    Skills: 'Skills',
    MultiChip: 'MultiChip',
    DateTimePicker: 'DateTimePicker',
    LocationCodeInput: 'LocationCodeInput',
    OutletLocationCodeInput: 'OutletLocationCodeInput',
    LineItemCodeInput: 'LineItemCodeInput',
    RiderIdInput: 'RiderIdInput',
    ShiftIdInput: 'ShiftIdInput',
    RiderPersonaIdInputWithLimits: 'RiderPersonaIdInputWithLimits',
    TransactionDuration: 'TransactionDuration',
    Notes: 'Notes',
    CustomFields: 'CustomFields',
    Text: 'Text',
    Select: 'Select',
    Boolean: 'Boolean',
    SalesCategoryId: 'SalesCategoryId'
});
